import api from "@/services/api"

class ReportService {

    getTemperatureReports( filterData = {}){
        return api.post('/reports/temperature?page='+filterData.page+'&perPage='+filterData.perPage,filterData)
    }

    TemperatureReportsExport( filterData = {}){
        return api.get('/reports/temperature/export', {params:filterData,responseType: 'blob'})
    }

    getTemperatureAlertReportsExport( filterData = {}){
        return api.get('/reports/alert/export', {params:filterData,responseType: 'blob'})
    }

    TemperatureRangeReportsExport( filterData = {}){
        return api.get('/reports/temperature-range/export', {params:filterData,responseType: 'blob'})
    }

    getTemperatureRangeReport( filterData = {} ){
        return api.post('/reports/temperature-range', filterData)
    }

    getTemperatureRangeReportTemplate(  ){
        return api.post('/reports/temperature-range-template')
    }

    getAlertReport( filterData = {} ){
        return api.post('/reports/alert?page='+filterData.page+'&perPage='+filterData.perPage, filterData)
    }

    getEmployees(){
        return api.post('/reports/employees')
    }

    getUserActionReport( filterData = {} ){
        return api.post('/reports/user-action?page='+filterData.page+'&perPage='+filterData.perPage, filterData)
    }

}

export default new ReportService();